import { html, SYSBaseElement } from "../../../../../../../_ovlclient/src"
import { ScreenNavigateTo } from "../../../../../../../_ovlclient/src/library/screenapi"
import { T } from "../../../../../../../_ovlclient/src/global/globals"

import { TableRefresh } from "../../../../../../../_ovlclient/src/library/table/tableapi"
import { SortGet } from "../../../../../../../_ovlclient/src/global/globalapi"

export class ScreenPackagingCustomerChooser extends SYSBaseElement {
  customerInformation: {}
  async getUI() {
    let allDataState = this.state.app.global.PKG.tables.PKGPackaging.data
    this.customerInformation = Object.keys(allDataState).reduce((val, k) => {
      if (!val[allDataState[k].CardCode]) {
        val[allDataState[k].CardCode] = {
          cardName: allDataState[k].CardName,
          orders: {},
        }
      }
      if (!val[allDataState[k].CardCode].orders[allDataState[k].DocNum]) {
        val[allDataState[k].CardCode].orders[allDataState[k].DocNum] = {
          posCount: 0,
        }
      }
      val[allDataState[k].CardCode].orders[allDataState[k].DocNum].posCount++
      return val
    }, {})
    let customerInformationSortedKeys = Object.keys(
      this.customerInformation
    ).sort((a, b) =>
      SortGet(
        this.customerInformation[a].cardName,
        this.customerInformation[b].cardName
      )
    )
    const handleClick = async (cardCode: string) => {
      this.state.app.screens.PKGPackagingCustomerChooser.customerInfo.cardCode =
        cardCode
      this.state.app.screens.PKGPackagingCustomerChooser.customerInfo.cardName =
        this.customerInformation[cardCode].cardName

      await TableRefresh("PKGPackaging", {
        forcedFilters: { staticFilter: { CardCode: cardCode } },
        preferCache: true,
        resetStrategy: { Filter: true, Sort: true, Selection: true },
      })
      ScreenNavigateTo("PKGPackaging")
    }
    return html`
      <div class="fd-layout-panel ">
        <div class="fd-layout-panel__header">
          <div class="fd-layout-panel__head">
            <h3 class="fd-layout-panel__title">
              ${T("PKGPackagingPackagingCustomerChooser")}
            </h3>
          </div>
        </div>
        <div class="fd-layout-panel__body PackagingCardsGrid ">
          ${customerInformationSortedKeys.map(
            (m) => html`<div class="fd-card PackagingCard" role="region">
              <a
                class="fd-card__header PackagingCardContent"
                tabindex="0"
                @click=${() => handleClick(m)}
              >
                <div class="fd-card__header-text">
                  <div class="fd-card__title-area">
                    <div class="fd-card__title">
                      ${this.customerInformation[m].cardName}
                    </div>
                    <span
                      class="fd-object-status fd-object-status--positive fd-card__counter"
                      >${Object.keys(this.customerInformation[m].orders)
                        .length}</span
                    >
                  </div>
                </div>
              </a>
            </div>`
          )}
        </div>
      </div>
    `
  }
}
